import { render, staticRenderFns } from "./myOperationAsk.vue?vue&type=template&id=c50f0c10&scoped=true"
import script from "./myOperationAsk.vue?vue&type=script&lang=js"
export * from "./myOperationAsk.vue?vue&type=script&lang=js"
import style0 from "./myOperationAsk.vue?vue&type=style&index=0&id=c50f0c10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50f0c10",
  null
  
)

export default component.exports